<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">รายการสั่งซื้อสินค้า</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายการสั่งซื้อสินค้า
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <!-- desktop filter data table -->
          <v-col cols="12" v-if="!IpadProSize && !IpadSize && !MobileSize">
            <v-row>
              <v-col cols="12">
                <span>รหัสฝ่ายขาย
                  <v-autocomplete
                    class="pl-1 d-inline-block"
                    style="width: 180px;"
                    v-model="selectSalesId"
                    :items="salesIdListMenu"
                    outlined dense
                    item-text="emp_code"
                    placeholder="เลือกรหัสฝ่ายขาย"
                    no-data-text="ไม่พบรหัสฝ่ายขายที่ค้นหา"
                    return-object
                    hide-details
                    @click="getSalesDataList()"
                    @change="onChangeSales"
                ></v-autocomplete>
                </span>
                <span class="pl-3">ข้อมูลลูกค้า
                  <v-autocomplete
                    class="pl-1 d-inline-block"
                    style="width: 250px;"
                    v-model="selectCusId"
                    :items="cusIdListMenu"
                    :menu-props="{ maxWidth: IpadProSize || IpadSize ? '250px' : MobileSize ? '319px' : '250px' }"
                    outlined dense
                    item-text="cus_data"
                    placeholder="เลือกข้อมูลลูกค้า"
                    no-data-text="ไม่พบเลือกข้อมูลลูกค้าที่ค้นหา"
                    return-object
                    hide-details
                    @change="onChange"
                ></v-autocomplete>
                </span>
                <span class="pl-3">สถานะ <v-select class="pl-1 d-inline-block" style="width: 170px;" v-model="selectStatus" @change="onChange" :items="statusListMenu" return-object item-text="text" outlined dense placeholder="เลือกสถานะ" hide-details></v-select></span>
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <!-- เลือกวันเริ่มต้น -->
                  <v-col cols="9" class="d-flex flex-row mb-6">
                    <span class="pr-3 d-inline-block pt-3">วันที่เริ่ม-สิ้นสุด</span>
                    <v-menu
                      ref="dialog"
                      v-model="modal"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          style="width: 220px;"
                          v-model="dateStart"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                          outlined
                          dense
                          placeholder="DD/MM/YYYY"
                          hide-details
                        ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                      </template>
                      <v-date-picker
                        color="#27AB9C"
                        ref="pickerDateStart"
                        v-model="dateFormatted"
                        :active-picker.sync="activePicker"
                        scrollable
                        reactive
                        no-title
                        locale="th"
                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">ยกเลิก
                        </v-btn>
                        <v-btn text color="primary" @click="getSelectStartDate(dateFormatted)">ตกลง
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                    <span class="px-3 d-inline-block pt-3">-</span>
                    <v-menu
                      ref="dialog1"
                      v-model="modal1"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateEnd"
                          v-bind="attrs"
                          v-on="on"
                          dense
                          placeholder="DD/MM/YYYY"
                          outlined
                          readonly
                          hide-details
                          style="width: 220px;"
                        ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                      </template>
                      <v-date-picker
                        color="#27AB9C"
                        v-model="dateFormatted2"
                        ref="pickerDateEnd"
                        :active-picker.sync="activePicker"
                        scrollable
                        no-title
                        locale="th"
                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                        :min="dateFormatted"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal1 = false">ยกเลิก
                        </v-btn>
                        <v-btn text color="primary" @click="getSelectDateEnd(dateFormatted2)">ตกลง
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="3" class="d-flex flex-row mb-6"></v-col>
                  <!-- <v-col cols="1" class="pt-3" style="text-align: center;">-</v-col> -->
                  <!-- เลือกวันสิ้นสุด -->
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!-- ipad pro, ipad filter data table -->
          <v-col cols="12" v-else-if="IpadProSize || IpadSize">
            <v-row>
              <v-col cols="4">
                <span>รหัสฝ่ายขาย</span>
                <v-autocomplete
                  v-model="selectSalesId"
                  :items="salesIdListMenu"
                  outlined dense
                  item-text="emp_code"
                  placeholder="เลือกรหัสฝ่ายขาย"
                  no-data-text="ไม่พบรหัสฝ่ายขายที่ค้นหา"
                  return-object
                  hide-details
                  @click="getSalesDataList()"
                  @change="onChangeSales"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <span>ข้อมูลลูกค้า</span>
                <v-autocomplete
                  v-model="selectCusId"
                  :items="cusIdListMenu"
                  :menu-props="{ maxWidth: IpadProSize || IpadSize ? '200px' : MobileSize ? '319px' : '250px' }"
                  outlined dense
                  item-text="cus_data"
                  placeholder="เลือกข้อมูลลูกค้า"
                  no-data-text="ไม่พบเลือกข้อมูลลูกค้าที่ค้นหา"
                  return-object
                  hide-details
                  @change="onChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <span>สถานะ</span>
                <v-select v-model="selectStatus" @change="onChange" :items="statusListMenu" return-object item-text="text" outlined dense placeholder="เลือกสถานะ" hide-details></v-select>
              </v-col>
              <v-col v-if="IpadProSize || IpadSize" cols="12" class="d-flex flex-row mb-2">
                <span class="pl-0 pr-3 d-inline-block pt-3">วันที่เริ่ม-สิ้นสุด </span>
                <!-- start date -->
                <v-menu
                  ref="dialog"
                  v-model="modal"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      style="width: 100px;"
                      v-model="dateStart"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="DD/MM/YYYY"
                      hide-details
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <!-- end date -->
                  <v-date-picker
                    color="#27AB9C"
                    ref="pickerDateStart"
                    v-model="dateFormatted"
                    :active-picker.sync="activePicker"
                    scrollable
                    reactive
                    no-title
                    locale="th"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">ยกเลิก
                    </v-btn>
                    <v-btn text color="primary" @click="getSelectStartDate(dateFormatted)">ตกลง
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <span class="px-3 d-inline-block pt-3">- </span>
                <!-- end date -->
                <v-menu
                  ref="dialog1"
                  v-model="modal1"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  left
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateEnd"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      placeholder="DD/MM/YYYY"
                      outlined
                      readonly
                      hide-details
                      style="width: 100px;"
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <v-date-picker
                    color="#27AB9C"
                    v-model="dateFormatted2"
                    ref="pickerDateEnd"
                    :active-picker.sync="activePicker"
                    scrollable
                    no-title
                    locale="th"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    :min="dateFormatted"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal1 = false">ยกเลิก
                    </v-btn>
                    <v-btn text color="primary" @click="getSelectDateEnd(dateFormatted2)">ตกลง
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col v-else cols="12">
                <v-row>
                  <!-- เลือกวันเริ่มต้น -->
                  <v-col cols="12">
                    <span>วันที่เริ่ม</span>
                    <v-menu
                      ref="dialog"
                      v-model="modal"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateStart"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                          outlined
                          dense
                          placeholder="DD/MM/YYYY"
                          hide-details
                        ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                      </template>
                      <v-date-picker
                        color="#27AB9C"
                        ref="pickerDateStart"
                        v-model="dateFormatted"
                        :active-picker.sync="activePicker"
                        scrollable
                        reactive
                        no-title
                        locale="th"
                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">ยกเลิก
                        </v-btn>
                        <v-btn text color="primary" @click="getSelectStartDate(dateFormatted)">ตกลง
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <!-- <v-col cols="1" class="pt-3" style="text-align: center;">-</v-col> -->
                  <!-- เลือกวันสิ้นสุด -->
                  <v-col cols="12">
                    <span>วันที่สิ้นสุด</span>
                    <v-menu
                      ref="dialog1"
                      v-model="modal1"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateEnd"
                          v-bind="attrs"
                          v-on="on"
                          dense
                          placeholder="DD/MM/YYYY"
                          outlined
                          readonly
                          hide-details
                        ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                      </template>
                      <v-date-picker
                        color="#27AB9C"
                        v-model="dateFormatted2"
                        ref="pickerDateEnd"
                        :active-picker.sync="activePicker"
                        scrollable
                        no-title
                        locale="th"
                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                        :min="dateFormatted"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal1 = false">ยกเลิก
                        </v-btn>
                        <v-btn text color="primary" @click="getSelectDateEnd(dateFormatted2)">ตกลง
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!-- search list order -->
          <v-col :cols="MobileSize ? disableTable === false ? 11 : 10 : IpadSize || IpadProSize ? 12 : 6" :class="MobileSize ? 'mb-3 pt-4' : IpadSize || IpadProSize ? 'px-0 mb-3 pt-5' : 'px-0 mb-3 pt-1'">
            <v-text-field v-model="search" placeholder="ค้นหารหัสการสั่งซื้อ" outlined dense hide-details>
              <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
            </v-text-field>
          </v-col>
          <!-- Filter Mobile -->
          <v-col v-if="MobileSize" cols="1" class="mb-3 pt-4">
            <v-btn @click="openFilterModal = !openFilterModal, clearFilter()" icon><v-icon color="#27AB9C">mdi-tune</v-icon></v-btn>
          </v-col>
          <!-- download excel -->
          <v-col v-if="disableTable === false" :cols="MobileSize ? 12 : IpadSize || IpadProSize ? 12 : 6" align="end" :class="MobileSize ? 'mb-3 pt-4' : IpadSize || IpadProSize ? 'px-0 mb-3 pt-3' : 'pl-0 mb-3 pt-1'">
            <v-spacer></v-spacer>
            <v-btn class="mr-2 white--text" color="#27AB9C" v-if="shop === 'Rattana' || shop === 'Sale Order'" @click="createCreditNote()">สร้างใบลดหนี้</v-btn>
            <v-btn color="#27AB9C" outlined @click="downloadExcel()"><v-icon>mdi-file-download-outline</v-icon>Export</v-btn>
            <v-overlay :value="loading" style="text-align:center; z-index: 99999;">
              <v-card width="450px" height="150px" class="pa-3" color="white" style="opacity: 80%;">
                <v-progress-circular indeterminate size="64" color="#00B500"></v-progress-circular>
                <p style="font-weight: 600; font-size: 18px; line-height: 24px; color: #333333; margin-top: 30px;">กำลังดาวน์โหลด กรุณารอสักครู่</p>
              </v-card>
            </v-overlay>
          </v-col>
          <!-- count list order -->
          <v-col :cols="userDetailSelling.is_gracz === 'no' && !MobileSize && !IpadProSize && !IpadSize ? 5 : 12" class="pt-3 pb-3" v-if="disableTable === false">
            <v-row dense>
              <v-col cols="12" class="pt-2">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการสั่งซื้อสินค้าทั้งหมด {{ showCountOrder }} รายการ</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="disableTable === false && userDetailSelling.is_gracz === 'no'" :cols="MobileSize || IpadProSize || IpadSize ? 12 : 7" align="end" :class="!MobileSize ? 'pt-1' : 'mb-3'">
            <v-btn :block="MobileSize || IpadProSize || IpadSize" :class="MobileSize || IpadProSize || IpadSize ? 'my-2 white--text' : 'mr-4 white--text'" style="border-radius: 4px;" @click="linkToEfact()" color="#27AB9C">เข้าระบบ E-Fact</v-btn>
            <v-btn :block="MobileSize || IpadProSize || IpadSize" :class="MobileSize || IpadProSize || IpadSize ? 'my-2 white--text' : 'mr-4 white--text'" style="border-radius: 4px;" @click="linkToEtax()" color="#27AB9C">เข้าระบบ E-Tax</v-btn>
            <v-btn :block="MobileSize || IpadProSize || IpadSize" :class="MobileSize || IpadProSize || IpadSize ? 'my-2' : ''" style="border-radius: 4px;" color="#27AB9C" outlined @click="gotoEtaxCredential()">E-Tax Credential</v-btn>
          </v-col>
          <!-- table list order -->
          <v-col cols="12" v-if="disableTable === false" class="mt-2">
            <v-data-table
            :headers="shop === 'Sale Order' ? headersSaleOrer : shop === 'Gracz' ? headersGracz : headersRattana"
            :items="orderList"
            :search="search"
            :page.sync="page"
            @pagination="countOrder"
            no-results-text="ไม่พบรายการสั่งซื้อสินค้า"
            no-data-text="ไม่มีรายการสั่งซื้อสินค้าในตาราง"
            :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="10"
            :class="shop === 'Sale Order' ? 'order-list-table' : shop === 'Gracz' ? 'order-list-table-gracz' : 'order-list-table-rattana'"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                <!-- {{ new Date(item.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }) }} -->
                {{  formatDateTH(item.created_at) }}
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'export'">
                  <v-chip small color="#ECF8EA" text-color="#1AB759">ดึงข้อมูลแล้ว</v-chip>
                </span>
                <span v-else-if="item.status === 'not_export'">
                  <v-chip small color="#FCF0DA" text-color="#FAAD14">รอการดึงข้อมูล</v-chip>
                </span>
              </template>
              <template v-slot:[`item.net_price`]="{ item }">
                {{ Number(item.net_price).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
              <template v-slot:[`item.required_invoice`]="{ item }">
                <!-- ไม่ได้ขอใบกำกับภาษี -->
                <span v-if="item.required_invoice === 'no'">{{'-'}}</span>
                <!-- มีการขอใบกำกับภาษี แต่ยังไม่ได้สร้างใบกำกับภาษี กดปุ่มเพื่อสร้าง -->
                <v-row v-else-if="item.required_invoice === 'yes' && (item.transaction_code === '' || item.transaction_code === null)">
                  <v-col>
                    <v-btn outlined color="#27AB9C" :class="!MobileSize? 'px-3' : ''" small @click="openModalEtaxInfor(item)">
                      <span>สร้างใบกำกับภาษี</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- มีการขอใบกำกับภาษี และมีใบกำกับภาษีแล้ว ดาวน์โหลดดูเอกสาร -->
                <v-row v-else-if="item.required_invoice === 'yes' && (item.transaction_code !== '' || item.transaction_code !== null)">
                  <v-col cols="12" v-if="shop === 'Rattana' || shop ==='Sale Order'">
                    <v-btn small dark color="#27AB9C" @click="openModalEtax(item)">ข้อมูลใบกำกับภาษี</v-btn>
                  </v-col>
                  <v-col cols="12" v-else>
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small @click="getEtaxPDF(item)"
                          v-bind="attrs" v-on="on" outlined class="pt-4 pb-4"
                          style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                          :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                        >
                          <v-icon color="#27AB9C" :size="18">mdi-file-document-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>ใบกำกับภาษี</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:[`item.transaction_status`]="{ item }">
                <v-chip small :color="getColor(item.transaction_status)" :text-color="getTextColor(item.transaction_status)">
                  {{ getStatus(item.transaction_status) }}
                </v-chip>
              </template>
              <template v-slot:[`item.manages`]="{ item }">
                <v-row>
                  <v-col>
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" x-small @click="orderDetail(item)" outlined class="pt-4 pb-4"
                        style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                        :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                        >
                          <v-icon color="#27AB9C" :size="18">mdi-file-document-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>รายละเอียด</span>
                    </v-tooltip>
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" x-small @click="openConfirmDeleteOrderModal(item)" outlined class="pt-4 pb-4 ml-1"
                        style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                        :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                        >
                          <v-icon color="#27AB9C" :size="18">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>ลบ</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
          <!-- empty data -->
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการสั่งซื้อสินค้า</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- dialog Filter Mobile order -->
    <v-dialog v-model="openFilterModal" width="350" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#FFFFFF" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#333333">ตัวกรอง</font></span>
          <v-btn icon dark @click="openFilterModal = false">
            <v-icon color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/>
        <v-card-text>
          <v-row>
            <v-col cols="12" align="start">
              <span>รหัสฝ่ายขาย</span>
              <v-autocomplete
                v-model="selectSalesId"
                :items="salesIdListMenu"
                outlined dense
                item-text="emp_code"
                placeholder="เลือกรหัสฝ่ายขาย"
                no-data-text="ไม่พบรหัสฝ่ายขายที่ค้นหา"
                return-object
                hide-details
                @click="getSalesDataList()"
                @change="onChangeSalesMobile"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" align="start">
              <span>ข้อมูลลูกค้า</span>
              <v-autocomplete
                v-model="selectCusId"
                :items="cusIdListMenu"
                :menu-props="{ maxWidth: IpadProSize || IpadSize ? '200px' : MobileSize ? '319px' : '250px' }"
                outlined dense
                item-text="cus_data"
                placeholder="เลือกข้อมูลลูกค้า"
                no-data-text="ไม่พบเลือกข้อมูลลูกค้าที่ค้นหา"
                return-object
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" align="start">
              <span>สถานะ</span>
              <v-select v-model="selectStatus" :items="statusListMenu" return-object item-text="text" outlined dense placeholder="เลือกสถานะ" hide-details></v-select>
            </v-col>
            <v-col cols="12" align="start" class="pb-0">
              <span>วันที่เริ่ม-สิ้นสุด</span>
            </v-col>
            <v-col cols="12" class="d-flex flex-row mb-2 pt-0">
              <!-- start date -->
              <v-menu
                ref="dialog"
                v-model="modal"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    style="width: 100px;"
                    v-model="dateStart"
                    v-bind="attrs"
                    v-on="on"
                    readonly
                    outlined
                    dense
                    placeholder="DD/MM/YYYY"
                    hide-details
                  ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                </template>
                <!-- end date -->
                <v-date-picker
                  color="#27AB9C"
                  ref="pickerDateStart"
                  v-model="dateFormatted"
                  :active-picker.sync="activePicker"
                  scrollable
                  reactive
                  no-title
                  locale="th"
                  :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">ยกเลิก
                  </v-btn>
                  <v-btn text color="primary" @click="getSelectStartDate(dateFormatted)">ตกลง
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <span class="px-3 d-inline-block pt-3">- </span>
              <!-- end date -->
              <v-menu
                ref="dialog1"
                v-model="modal1"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                left
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateEnd"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    placeholder="DD/MM/YYYY"
                    outlined
                    readonly
                    hide-details
                    style="width: 100px;"
                  ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                </template>
                <v-date-picker
                  color="#27AB9C"
                  v-model="dateFormatted2"
                  ref="pickerDateEnd"
                  :active-picker.sync="activePicker"
                  scrollable
                  no-title
                  locale="th"
                  :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                  :min="dateFormatted"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal1 = false">ยกเลิก
                  </v-btn>
                  <v-btn text color="primary" @click="getSelectDateEnd(dateFormatted2)">ตกลง
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-col>
                <v-btn block dense color="#27AB9C" class="white--text" @click="submitFilter()">ค้นหา</v-btn>
              </v-col>
              <v-col>
                <v-btn block dense dark outlined color="#27AB9C" @click="clearFilter()">ล้าง</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog comfirm delete order -->
    <v-dialog  v-model="dialogConfirmDeleteOrder" width="400" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">ลบรายการสั่งซื้อสินค้า</font></span>
          <v-btn icon dark @click="dialogConfirmDeleteOrder = false">
            <v-icon color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/><br/>
        <v-card-text >
          <span>คุณต้องการลบรายการสั่งซื้อสินค้านี้ ใช่หรือไม่ ?</span>
        </v-card-text>
        <v-card-actions >
          <v-container >
            <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="closeConfirmDeleteOrder()">ยกเลิก</v-btn>
            <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="deleteOrder()">ตกลง</v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- โหลดข้อมูลใบกำกับภาษี -->
    <EtaxDocument ref="EtaxDocument"/>
    <!-- ดูรายละเอียดและตั้งค่าใบกำกับภาษี -->
    <EtaxDocumentInformation ref="EtaxDocumentInformation"/>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
import moment from 'moment'
export default {
  components: {
    EtaxDocument: () => import('@/components/Gracz/Modal/EtaxDocument'),
    EtaxDocumentInformation: () => import('@/components/Gracz/Modal/EtaxDocumentInformation')
  },
  data () {
    return {
      openFilterModal: false,
      showCountOrder: 0,
      pageCount: 5,
      page: 1,
      itemsPerPage: 10,
      orderList: [],
      disableTable: true,
      search: '',
      headersGracz: [
        { text: 'วันที่', value: 'created_at', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสการสั่งซื้อ', value: 'order_number', filterable: true, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสลูกค้า', value: 'cus_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', filterable: false, sortable: false, width: '230px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาสุทธิ', value: 'net_price', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสฝ่ายขาย', value: 'sales_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', filterable: false, sortable: false, width: '120px', class: 'backgroundTable fontTable--text' }
      ],
      headersRattana: [
        { text: 'วันที่', value: 'created_at', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสการสั่งซื้อ', value: 'order_number', filterable: true, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสลูกค้า', value: 'cus_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', filterable: false, sortable: false, width: '230px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาสุทธิ', value: 'net_price', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ใบกำกับภาษี', value: 'required_invoice', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', filterable: false, sortable: false, width: '120px', class: 'backgroundTable fontTable--text' }
      ],
      headersSaleOrer: [
        { text: 'วันที่', value: 'created_at', filterable: false, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสการสั่งซื้อ', value: 'order_number', filterable: true, sortable: false, width: '180px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสลูกค้า', value: 'cus_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', filterable: false, sortable: false, width: '230px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาสุทธิ', value: 'net_price', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสฝ่ายขาย', value: 'sales_code', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'ใบกำกับภาษี', value: 'required_invoice', filterable: false, sortable: false, width: '100px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะการชำระเงิน', value: 'transaction_status', filterable: false, sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', filterable: false, sortable: false, width: '120px', class: 'backgroundTable fontTable--text' }
      ],
      salesIdListMenu: [],
      cusIdListMenu: [],
      statusListMenu: [
        { text: 'ทั้งหมด', status: 'all' },
        { text: 'ดึงข้อมูลแล้ว', status: 'export' },
        { text: 'รอการดึงข้อมูล', status: 'not_export' }
      ],
      selectList: [
        { text: '1 สัปดาห์' },
        { text: '1 เดือน' },
        { text: '1 ปี' }
      ],
      selectSalesId: { emp_id: '', emp_code: 'ทั้งหมด' },
      selectCusId: { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' },
      selectStatus: { text: 'ทั้งหมด', status: 'all' },
      selected: '',
      modal: false,
      modal1: false,
      date: '',
      dateStart: '',
      dateEnd: '',
      startDate: '',
      endDate: '',
      dateFormatted: '',
      dateFormatted2: '',
      activePicker: null,
      userDetailSelling: '',
      customerData: '',
      orderNumber: '',
      dialogConfirmDeleteOrder: false,
      exportData: '',
      loading: false,
      shop: ''
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/OrderListrMobile').catch(() => {})
      } else {
        this.$router.push('/Order/OrderList').catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      this.checkShop()
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
      this.getSalesDataList()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    if (this.shop === 'Sale Order') {
      this.$EventBus.$on('getOrderList', this.getDataSaleOrder)
    } else {
      this.$EventBus.$on('getOrderList', this.getData)
    }
    this.$on('hook:beforeDestroy', () => {
      this.$EventBus.$off('getOrderList')
    })
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    },
    async getData () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        emp_id: '',
        emp_code: this.selectSalesId ? this.selectSalesId.emp_code === 'ทั้งหมด' ? '' : this.selectSalesId.emp_code : '',
        cus_id: this.selectCusId ? this.selectCusId.cus_id : '',
        status_export: this.selectStatus.status,
        start_date: this.dateFormatted,
        end_date: this.dateFormatted2,
        page: this.page,
        count_item: this.itemsPerPage === -1 ? '' : this.itemsPerPage
      }
      await this.$store.dispatch('actionsGraczListOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczListOrder
      if (response.message === 'List orders success') {
        this.$store.commit('closeLoader')
        this.orderList = response.data.orders
        if (this.orderList.length !== 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
        if (localStorage.getItem('createCreditNote') !== null) {
          var itemData = JSON.parse(Decode.decode(localStorage.getItem('createCreditNote')))
          this.openModalEtax(itemData)
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getDataSaleOrder () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        emp_id: '',
        emp_code: this.selectSalesId ? this.selectSalesId.emp_code === 'ทั้งหมด' ? '' : this.selectSalesId.emp_code : '',
        cus_id: this.selectCusId ? this.selectCusId.cus_id : '',
        status_export: this.selectStatus.status,
        start_date: this.dateFormatted,
        end_date: this.dateFormatted2,
        page: this.page,
        count_item: this.itemsPerPage === -1 ? '' : this.itemsPerPage
      }
      await this.$store.dispatch('actionsGraczListOrderSaleOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczListOrderSaleOrder
      if (response.message === 'List orders success') {
        this.$store.commit('closeLoader')
        this.orderList = response.data.orders
        if (this.orderList.length !== 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
        if (localStorage.getItem('createCreditNote') !== null) {
          var itemData = JSON.parse(Decode.decode(localStorage.getItem('createCreditNote')))
          this.openModalEtax(itemData)
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getSalesDataList () {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        emp_code: this.selectSalesId.emp_code === 'ทั้งหมด' ? 'all' : this.selectSalesId.emp_code
      }
      await this.$store.dispatch('actionsGraczGetCustomerAndSalesList', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczGetCustomerAndSalesList
      if (response.message === 'Get list sales and customer success.') {
        // employee
        var all = { emp_id: '', emp_code: 'ทั้งหมด' }
        this.salesIdListMenu = response.data.list_employee
        this.salesIdListMenu.unshift(all)
        // customer
        var empAll = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
        response.data.list_customer.forEach(e => {
          e.cus_data = e.cus_code + ' ' + e.cus_name
        })
        this.cusIdListMenu = response.data.list_customer
        this.cusIdListMenu.unshift(empAll)
      } else {
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    downloadData () {
      var item = ''
      this.openModalEtax(item)
    },
    createCreditNote () {
      console.log('สร้างใบลดหนี้')
      if (this.MobileSize === false) {
        this.$router.push({ path: '/Order/CreditNote' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/CreditNoteMobile' }).catch(() => {})
      }
    },
    async downloadExcel () {
      this.loading = true
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        emp_id: '',
        emp_code: this.selectSalesId ? this.selectSalesId.emp_code === 'ทั้งหมด' ? '' : this.selectSalesId.emp_code : '',
        cus_id: this.selectCusId ? this.selectCusId.cus_id : '',
        status_export: this.selectStatus.status,
        start_date: this.dateFormatted,
        end_date: this.dateFormatted2,
        page: this.page,
        count_item: this.itemsPerPage === -1 ? '' : this.itemsPerPage
      }
      await this.$store.dispatch('actionsGraczExportOrderData', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczExportOrderData
      if (response.message === 'export data success!') {
        this.loading = false
        this.exportData = response.data.path
        const link = document.createElement('a')
        link.href = this.exportData
        link.download = 'export list order data'
        link.click()
      } else if (response.message === 'This user is unauthorized.') {
        this.loading = false
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else if (response.message === 'Not access this function.') {
        this.loading = false
        this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else {
        this.loading = false
        var [msg, iconMsg] = this.getErrorMsg(response.message)
        this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
      }
    },
    onChangeSalesMobile () {
      this.selectCusId = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
      this.getSalesDataList()
    },
    onChangeSales () {
      this.selectCusId = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
      this.getSalesDataList()
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    },
    onChange () {
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    },
    async getSelectStartDate (val) {
      if (val !== '') {
        this.$refs.dialog.save(val)
        this.dateStart = ''
        this.dateSelectFunctionOne = ''
        this.clearEndDate()
        this.dateSelectFunctionOne = new Date(this.dateFormatted)
        this.dateStart = this.formatDate(new Date(this.dateSelectFunctionOne.setDate(this.dateSelectFunctionOne.getDate()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))
        this.modal = false
      }
      // this.getData()
    },
    clearEndDate () {
      this.dateEnd = ''
      this.dateSelectFunctionTwo = ''
      this.dateFormatted2 = ''
    },
    getSelectDateEnd (val) {
      if (val !== '') {
        this.$refs.dialog1.save(val)
        this.dateSelectFunctionTwo = ''
        this.dateSelectFunctionTwo = new Date(this.dateFormatted2)
        this.dateEnd = this.formatDate(new Date(this.dateSelectFunctionTwo.setDate(this.dateSelectFunctionTwo.getDate()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))
        this.modal1 = false
        if (!this.MobileSize) {
          if (this.shop === 'Sale Order') {
            this.getDataSaleOrder()
          } else {
            this.getData()
          }
        }
      }
    },
    submitFilter () {
      this.openFilterModal = !this.openFilterModal
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    },
    clearFilter () {
      this.selectSalesId = { emp_id: '', emp_code: 'ทั้งหมด' }
      this.selectCusId = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
      this.selectStatus = { text: 'ทั้งหมด', status: 'all' }
      this.dateStart = ''
      this.dateSelectFunctionOne = ''
      this.dateFormatted = ''
      this.dateEnd = ''
      this.dateSelectFunctionTwo = ''
      this.dateFormatted2 = ''
    },
    dateFormat (inputDate, format) {
      // parse the input date
      const date = new Date(inputDate)
      // extract the parts of the date
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      // replace the month
      format = format.replace('MM', month.toString().padStart(2, '0'))
      // replace the year
      if (format.indexOf('yyyy') > -1) {
        format = format.replace('yyyy', year.toString())
      } else if (format.indexOf('yy') > -1) {
        format = format.replace('yy', year.toString().substr(2, 2))
      }
      // replace the day
      format = format.replace('dd', day.toString().padStart(2, '0'))
      return format
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateToShow (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    countOrder (pagination) {
      this.showCountOrder = pagination.itemsLength
      this.itemsPerPage = pagination.itemsPerPage
      this.page = pagination.page
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    },
    orderDetail (item) {
      var orderNumber = item.order_number
      if (this.MobileSize === false) {
        this.$router.push({ path: `/Order/OrderDetail?orderNumber=${orderNumber}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/OrderDetailMobile?orderNumber=${orderNumber}` }).catch(() => {})
      }
    },
    openConfirmDeleteOrderModal (item) {
      this.dialogConfirmDeleteOrder = true
      this.orderNumber = item.order_number
    },
    closeConfirmDeleteOrder () {
      this.dialogConfirmDeleteOrder = false
    },
    async deleteOrder () {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        order_number: this.orderNumber
      }
      await this.$store.dispatch('actionsGraczDeleteOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczDeleteOrder
      if (response.status === 200) {
        this.closeConfirmDeleteOrder()
        this.$swal.fire({ icon: 'success', text: response.message, showConfirmButton: false, timer: 2000 })
        if (this.shop === 'Sale Order') {
          this.getDataSaleOrder()
        } else {
          this.getData()
        }
      } else {
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getEtaxPDF (val) {
      this.loading = true
      var data = {
        transactionCode: val.transaction_code
      }
      await this.$store.dispatch('actionsDownloadEtaxDocument', data)
      var response = await this.$store.state.ModuleSaleOrderEtax.stateDownloadEtaxDocument
      if (response.result === 'OK') {
        if (response.etaxResponse.status === 'OK') {
          this.loading = false
          const link = document.createElement('a')
          link.href = response.etaxResponse.pdfURL
          link.download = 'E-tax'
          link.click()
        }
      } else {
        this.loading = false
        if (response.error === 'Access key is invalid') {
          this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถดาวน์โหลด E-tax ได้ Access key ไม่ถูกต้อง', showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async linkToEfact () {
      await this.$store.dispatch('actionsLoginBySharedTokenEfac')
      var response = await this.$store.state.ModuleSaleOrderEtax.stateLoginBySharedTokenEfac
      console.log('response', response)
      window.open(response.data.link, '_blank')
    },
    linkToEtax () {
      if (process.env.VUE_APP_DOMAIN === 'https://panit.one.th/') {
        // E-Tax PRD
        window.open('https://etax.one.th/portal/login', '_blank')
      } else {
        // E-Tax UAT
        window.open('https://devinet-etax.one.th/portal/login', '_blank')
      }
    },
    gotoEtaxCredential () {
      this.$EventBus.$emit('changeNavEtax')
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/EtaxCredentialMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/EtaxCredential' }).catch(() => {})
      }
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    openModalEtax (item) {
      this.$refs.EtaxDocument.open(item)
    },
    openModalEtaxInfor (item) {
      this.$refs.EtaxDocumentInformation.open(item)
    },
    getColor (item) {
      if (item === 'Pending') return '#FCF0DA'
      else if (item === 'Not Paid') return '#FCF0DA'
      else if (item === 'Success') return '#F0F9EE'
      else if (item === 'Approve') return '#F0F9EE'
      else if (item === 'Fail') return '#F7D9D9'
      else if (item === 'Credit Term') return '#E5EFFF'
      else return '#F7D9D9'
    },
    getTextColor (item) {
      if (item === 'Pending') return '#E9A016'
      else if (item === 'Not Paid') return '#E9A016'
      else if (item === 'Success') return '#1AB759'
      else if (item === 'Approve') return '#1AB759'
      else if (item === 'Fail') return '#D1392B'
      else if (item === 'Credit Term') return '#1B5DD6'
      else return '#D1392B'
    },
    getStatus (item) {
      if (item === 'Pending') return 'รออนุมัติ'
      else if (item === 'Not Paid') return 'ยังไม่ชำระเงิน'
      else if (item === 'Success') return 'ชำระเงินสำเร็จ'
      else if (item === 'Approve') return 'วางบิล'
      else if (item === 'Fail') return 'ชำระเงินไม่สำเร็จ'
      else if (item === 'Credit Term') return 'ชำระเงินแบบเครดิตเทอม'
      else return 'ยกเลิกคำสั่งซื้อ'
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found.') {
        return ['ไม่พบพนักงาน', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === "The order doesn't belong to this shop.") {
        return ['คำสั่งซื้อไม่ได้เป็นของร้านนี้', 'warning']
      } else if (msg === 'Failed to create E-tax. Please check and try again.') {
        return ['ไม่สามารถสร้าง E-tax ได้ โปรดตรวจสอบและลองอีกครั้ง', 'warning']
      } else if (msg === 'Access key is invalid') {
        return ['ไม่สามารถสร้าง E-tax ได้ Access key ไม่ถูกต้อง', 'warning']
      } else if (msg === 'Failed to create E-tax. Please setting E-tax credentials.') {
        return ['ไม่สามารถสร้างใบกำกับภาษีได้ เนื่องจากร้านค้ายังไม่ได้ยืนยัน E-Tax Credential', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .order-list-table table {
    tbody {
      tr {
        td:nth-child(10) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(10) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
  ::v-deep .order-list-table-rattana table {
    tbody {
      tr {
        td:nth-child(8) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(8) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
  ::v-deep .order-list-table-gracz table {
    tbody {
      tr {
        td:nth-child(8) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(8) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 2;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
</style>
